export default __webpack_public_path__ + "static/media/GroundskeeperWillie.b2ee1338.png";